// extracted by mini-css-extract-plugin
export default {"layout":"PartnersLayout_layout__4vt1m","outletContainer":"PartnersLayout_outletContainer__nKKUl","desktop":"PartnersLayout_desktop__3pWLY","outlet":"PartnersLayout_outlet__tIC-G"};